import React from 'react'
import { Col } from "react-bootstrap"
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { error, bordererror } from './style.js'




export function renderDatePickerField(field) {

  const date = field.input.value ? moment(field.input.value) : null
  const dateString = date ? date.format('MM-DD-YYYY') : null
  const inputstyle = field.meta.touched && field.meta.error ? bordererror : {}
  const disabled = field.disabled;
  return (
    <div className='form-group'>
      <label className={field.labelattrs}>{field.label}</label>
      <Col className={field.inputattrs}>
        <DatePicker
          {...field.input}
          value={dateString}
          placeholderText={field.placeholder ? field.placeholder : ''}
          selected={date}
          className="form-control"
          dateFormat="MM/DD/YYYY"
          title={field.title}
          style={inputstyle}
          disabled={disabled ? "disabled" : ""}
        />
        {field.meta.touched && field.meta.error && <span style={error}>*{field.meta.error}</span>}
      </Col>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/modules/components/datepickercomponent.js